import React from 'react'
import { Skeleton } from 'src/component/ui/skeleton'

interface ReadOnlyFieldProps {
  label: string
  value: string
  isLoading?: boolean
}

export const ReadOnlyField = ({ label, value, isLoading = false }: ReadOnlyFieldProps): React.ReactElement => (
  <div className="space-y-2">
    <label className="block text-sm font-roboto-condensed font-bold text-mist">{label}</label>
    {isLoading ? <Skeleton className="w-28 h-5" /> : <p className="text-sm font-evogria text-light-gray uppercase">{value}</p>}
  </div>
)
